import cn, {Argument} from 'classnames';
interface IQrCode {
  link: string;
  size?: 'small' | 'medium' | 'large' | 'xLarge';
  color?: 'gray' | 'black' | 'white';
}

export function QrCode({link, size = 'medium', color = 'gray'}: IQrCode) {
  const sizingList = {
    small: 'text-2xl',
    medium: 'text-3xl',
    large: 'text-4xl',
    xLarge: 'text-5xl',
  };
  const iconSize = sizingList[size];

  const iconClickHandler = () => {
    window.open(link, '_blank');
  };
  const colors = {
    gray: 'text-gray-600',
    black: 'text-black',
    white: 'text-white',
  };
  return (
    <i
      onClick={iconClickHandler}
      className={cn(
        'ml-1 text-gray-600 icon-qr-code shrink-0',
        iconSize,
        colors[color],
      )}
    />
  );
}
